import axios from "axios";
import AppStore from "../../Store";
import { create } from "mobx-persist";
const appStore = new AppStore();
const hydrate = create({
  storage: localStorage,
  jsonify: true
});

// Add a request interceptor
axios.interceptors.request.use(
  config => {
    // Do something before request is sent
    const appStore = JSON.parse(localStorage.getItem("appStore") || "{}");
    if (appStore["token"]) {
      config.headers.Authorization = `Bearer ${appStore["token"]}`;
    }

    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  response => {
    // Do something with response data
    return response;
  },
  async (error) => {
    //  401 aldığında localdeki tokeni silmeli.
    if (error.response && error.response.status === 401) {
      const store = await hydrate("appStore", appStore)
      store.setToken(undefined);
      // window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default axios;
